<template>
  <div
    class="sc-tooltip-container"
    :ref="'container'">
    <div class="sc-tooltip-icon">
      <span
        class="material-icons"
        @mouseover="onHover"
        @mouseleave="isHovered = false"
        @click="onClick"
        :class="{ 'sc-tooltip-icon-active' : isHovered || isClicked }">
          {{ icon }}
      </span>
    </div>
    <div
      v-if="isHovered || isClicked"
      class="sc-tooltip-text"
      :ref="textId"
      :class="tooltipClass"
      :style="{ width: textWidth + 'px', left: textLeft + 'px', top: textTop + 'px' }"
      @click="isClicked = false">
        {{ text }}
    </div>
  </div>
</template>

<script>
import utilsMixin from '../mixins/utils'

export default {
  name: 'ScTooltip',
  mixins: [utilsMixin],
  props: {
    icon: {
      type: String,
      default: 'info'
    },
    text: {
      type: String
    },
    tooltipClass: {
      type: String
    }
  },
  mounted () {
    this.textId = this.generateId()
    this.setWindowMeasures()
    window.addEventListener('resize', this.setWindowMeasures)
  },
  data () {
    return {
      isClicked: false,
      isHovered: false,
      windowWidth: 0,
      windowHeight: 0,
      textWidth: 325,
      textHeight: null,
      textTop: null,
      textLeft: null,
      sideSpaceForText: 20,
      textId: null
    }
  },
  methods: {
    getTextWidth (text, font) {
      const canvas = document.createElement('canvas')
      const context = canvas.getContext('2d')
      context.font = font
      const metrics = context.measureText(text)
      return metrics.width
    },
    onHover () {
      this.isHovered = true
      this.setTooltipMeasures()
    },
    onClick () {
      this.isClicked = !this.isClicked
      if (this.isClicked) {
        this.setTooltipMeasures()
        setTimeout(() => {
          this.addClickEventToWindow()
        })
      }
    },
    addClickEventToWindow () {
      window.addEventListener('click', this.hideText)
    },
    hideText () {
      this.isClicked = false
      window.removeEventListener('click', this.hideText)
    },
    setWindowMeasures () {
      this.windowWidth = window.innerWidth
      this.windowHeight = window.innerHeight
    },
    setTooltipMeasures () {
      setTimeout(() => {
        this.countTextWidth()
        this.countTextHeight()
        this.countTextPosition()
      })
    },
    countTextWidth () {
      const textElement = this.$refs[this.textId]
      if (!textElement) return
      const font = window.getComputedStyle(textElement, null).getPropertyValue('font')
      const textWidthInPixels = Math.round(this.getTextWidth(this.text, font))
      this.textWidth = textWidthInPixels < 300 ? textWidthInPixels + 25 : 300
    },
    countTextHeight () {
      const textElement = this.$refs[this.textId]
      if (!textElement) return
      const heightString = window.getComputedStyle(textElement, null).height
      this.textHeight = parseInt(heightString.substring(0, heightString.length - 2))
    },
    countTextPosition () {
      const container = this.$refs.container
      const containerLeftValue = Math.round(container.getBoundingClientRect().left)
      const containerTopValue = Math.round(container.getBoundingClientRect().top)
      const rightSpaceForText = this.windowWidth - containerLeftValue
      if (rightSpaceForText < this.textWidth + this.sideSpaceForText) {
        this.textLeft = (this.textWidth + this.sideSpaceForText - rightSpaceForText) * -1
      }
      const topSpaceForText = containerTopValue - this.sideSpaceForText
      if (topSpaceForText > this.textHeight) {
        this.textTop = (this.textHeight + 5) * -1
      } else {
        this.textTop = 30
      }
    }
  },
  destroyed () {
    window.removeEventListener('resize', this.setWindowMeasures)
  }
}
</script>

<style scoped lang="scss">
.sc-tooltip-container {
  position: relative;
}
.sc-tooltip-text {
  position: absolute;
  color: $sc-tooltip-text-color;
  background-color: $sc-tooltip-bg;
  padding: $sc-tooltip-padding;
  text-align: left;
  border: 1px solid $sc-tooltip-text-border;
  cursor: pointer;
  z-index: 2;
}
.sc-tooltip-icon {
  color: $sc-tooltip-icon-color;
  cursor: pointer;
  display: inline-block;

  .material-icons {
    font-size: $sc-tooltip-icon-font-size;
  }
}
.sc-tooltip-icon-active {
  color: $sc-tooltip-icon-color-active;
}
</style>
